// istanbul ignore file

const EmailRegex = /^\w+((\.|[-+]+|\.-)\w+)*-*@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*\.[a-zA-Z]{2,}$/i;

const Validate = {
    required: {
        pattern: /.+/,
        message: 'form.error_message.required',
    },
    maxLength20: {
        pattern: /^.{0,20}$/,
        message: 'form.error_message.max_length_20',
    },
    maxLength40: {
        pattern: /^.{0,40}$/,
        message: 'form.error_message.max_length_40',
    },
    maxLength60: {
        pattern: /^.{0,60}$/,
        message: 'form.error_message.max_length_60',
    },
    identityDocument: {
        pattern: /^.{6,}$/,
        message: 'form.error_message.identity_document',
    },
    email: {
        pattern: EmailRegex,
        message: 'form.error_message.email',
    },
    password: {
        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/,
        message: 'form.error_message.password_invalid_format',
    },
    passwordConfirmation: {
        pattern: (input, form) => {
            const password = form.password || form.find((f) => f.id === 'password');
            return password.value && password.value !== input.value;
        },
        message: 'form.error_message.password_match',
    },
};

const getInputError = (input, form) => {
    const errors = input.validate && !input.hidden &&
        input.validate.find(({ pattern }) => {
            if (pattern instanceof RegExp) return !new RegExp(pattern).test(input.value || '');
            if (typeof pattern === 'function') return pattern(input, form);
            return false;
        });
    return errors ? errors.message : null;
};

const getFormErrors = (form) => {
    const errors = Object.keys(form).reduce((p, key) => ({
        ...p,
        [key]: {
            ...form[key],
            error: getInputError(form[key], form),
        },
    }), {});
    return [
        errors,
        !!Object.values(errors).find(({ error }) => error),
    ];
};

const getCustomerValues = (obj) =>
    Object.keys(obj).reduce((p, k) => ({
        ...p,
        [k]: obj[k].value,
    }), {});

const setCustomerValues = (obj, source = {}) =>
    Object.keys(obj).reduce((p, k) => ({
        ...p,
        [k]: { ...obj[k], value: source[k] || null },
    }), {});

export { getCustomerValues, setCustomerValues, getInputError, getFormErrors, Validate }
